import React from 'react';
import styles from './HexaContainer.scss';

const innerCubeStyle = {
    position: 'absolute',
    top: '-0.1rem',
    left: '-1px',
}
const innerHexaStyle = {
    position:'absolute',
    top:'-.25%',
}

export default class HexaContainer extends React.Component{

    state = {
        backgroundImageUrl: null || this.props.backgroundImageUrl,
        elements: null || this.props.elements,
        extraClass: null || this.props.extraClass,
        style: null || this.props.style,
        type: null || this.props.type,
    }

    render(){

        if(this.state.elements){
            if(this.state.type === 'header'){
                return(
                    <React.Fragment>
                        <div className={styles.super_cube} style={this.props.style}>
                            <div className={styles.hexa_supreme}>
                                <div className={styles.hexa_supreme_in1}>
                                    <div className={styles.hexa_supreme_in2}></div>
                                </div>
                            </div>
                            <div className={styles.outer_cube} style={innerCubeStyle}>
                                <div className={[styles.cube__face, styles.cube__face__back].join(' ')}></div>
                                <div className={[styles.cube__face, styles.cube__face__bottom].join(' ')}></div>
                                <div className={[styles.cube__face, styles.cube__face__front].join(' ')}></div>
                                <div className={[styles.cube__face, styles.cube__face__left].join(' ')}></div>
                                <div className={[styles.cube__face, styles.cube__face__right].join(' ')}></div>
                                <div className={[styles.cube__face, styles.cube__face__top].join(' ')}></div>
                            </div>
                        </div>
                        <div className={this.props.extraClass}>
                            {this.state.elements}
                        </div>
                    </React.Fragment>
                );
            }
            if(this.state.type === 'project'){
                return(
                    <React.Fragment>
                        <div className={styles.super_cube + ' ' + styles.project} style={this.props.style}>
                            <div className={styles.hexa_supreme}>
                                <div className={styles.hexa_supreme_in1}>
                                    <div className={styles.hexa_supreme_in2}></div>
                                </div>
                            </div>
                            <div className={styles.hexa_supreme + ' ' + styles.hexa_supreme_inner} style={innerHexaStyle}>
                                <div className={styles.hexa_supreme_in1}>
                                    <div className={styles.hexa_supreme_in2} style={{backgroundImage:'url('+this.state.backgroundImageUrl+')'}}></div>
                                </div>
                            </div>
                            <div className={styles.outer_cube} style={innerCubeStyle}>
                                <div className={[styles.cube__face, styles.cube__face__back].join(' ')} style={{backgroundColor:'transparent'}}></div>
                                <div className={[styles.cube__face, styles.cube__face__bottom].join(' ')} style={{backgroundColor:'transparent'}}></div>
                                <div className={[styles.cube__face, styles.cube__face__front].join(' ')}></div>
                                <div className={[styles.cube__face, styles.cube__face__left].join(' ')} style={{backgroundColor:'transparent'}}></div>
                                <div className={[styles.cube__face, styles.cube__face__right].join(' ')} style={{backgroundColor:'transparent'}}></div>
                                <div className={[styles.cube__face, styles.cube__face__top].join(' ')} style={{backgroundColor:'transparent'}}></div>
                            </div>
                            <div className={styles.super_cube_content}>
                                {this.state.elements}
                            </div>
                        </div>
                    </React.Fragment>
                );
            }
            if(this.state.type === 'project_detail'){
                return(
                    <React.Fragment>
                        <div className={styles.super_cube + ' ' + styles.project + ' ' + this.props.extraClass} style={this.props.style}>
                            <div className={styles.hexa_supreme}>
                                <div className={styles.hexa_supreme_in1}>
                                    <div className={styles.hexa_supreme_in2}></div>
                                </div>
                            </div>
                            <div className={styles.hexa_supreme + ' ' + styles.hexa_supreme_inner} style={innerHexaStyle}>
                                <div className={styles.hexa_supreme_in1}>
                                    <div className={styles.hexa_supreme_in2} style={{backgroundImage:'url('+this.state.backgroundImageUrl+')'}}></div>
                                </div>
                            </div>
                            <div className={styles.outer_cube} style={innerCubeStyle}>
                                <div className={[styles.cube__face, styles.cube__face__back].join(' ')} style={{backgroundColor:'transparent'}}></div>
                                <div className={[styles.cube__face, styles.cube__face__bottom].join(' ')} style={{backgroundColor:'transparent'}}></div>
                                <div className={[styles.cube__face, styles.cube__face__front].join(' ')}></div>
                                <div className={[styles.cube__face, styles.cube__face__left].join(' ')} style={{backgroundColor:'transparent'}}></div>
                                <div className={[styles.cube__face, styles.cube__face__right].join(' ')} style={{backgroundColor:'transparent'}}></div>
                                <div className={[styles.cube__face, styles.cube__face__top].join(' ')} style={{backgroundColor:'transparent'}}></div>
                            </div>
                            <div className={styles.super_cube_content}>
                                {this.state.elements}
                            </div>
                        </div>
                    </React.Fragment>
                );
            }
        }
        if(this.state.type === 'empty'){
            return(
                <div className={styles.super_cube + ' ' + this.props.extraClass} style={this.props.style}>
                    <div className={styles.hexa_supreme}>
                        <div className={styles.hexa_supreme_in1}>
                            <div className={styles.hexa_supreme_in2}></div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/Components/HexaContainer/HexaContainer.js